import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./PlayersLayout.module.css";
// import GameTableSeat from "../GameTableSeat/GameTableSeat";
import { GameTableSeat } from "@themed-components";
import { 
  useGameTableDimensions,
  useGameDefinition,
  usePlayerSeat as useGamePlayerSeat,
  useIsTourneyGame
} from "@/src/hooks/data/useGameTable";
import { doesExist } from "../../../Common/utils/GameUtils";
import { useDispatch } from "react-redux";
import { updatePlayerPositionsOnTable } from "@/Poker/redux/slices/gameTableSlice";
import EmojiThrower from "../EmojiThrower/EmojiThrower.jsx";
import SlipperLottie from "../../assets/throwables/SlipperSmack.json";
import EmojiThrowManager from "../EmojiThrowerManager/EmojiThrowerManager";

export default function PlayersLayout({ tempTableId, gameTableLoaded }) {
  const gameTableDimensions = useGameTableDimensions(tempTableId);
  const gameDefinition = useGameDefinition(tempTableId);
  const { maxPlayers, playersPerTable } = gameDefinition || {};
  const playerSeat = useGamePlayerSeat(tempTableId);
  const isTourneyGame = useIsTourneyGame(tempTableId);
  const [defaultPlayersArray, setDefaultPlayersArray] = useState([]);
  const [showPlayersOnTable, setShowPlayersOnTable] = useState(false);
  const playersOnTable = isTourneyGame ? playersPerTable : maxPlayers;
  const dispatch = useDispatch();

  const returnPlayerPositions = useCallback(
    (totalPlayers, index) => {
      let position = {
        top: 0,
        left: 0,
      };
      if (totalPlayers === 8) {
        switch (index) {
          case 0:
            position = {
              top: gameTableDimensions.height,
              left: gameTableDimensions.width / 2,
            };
            break;
          case 1:
            position = {
              top: gameTableDimensions.height / 1.3,
              left: 30,
            };
            break;
          case 2:
            position = {
              top: gameTableDimensions.height / 2.5,
              left: 35,
            };
            break;
          case 3:
            position = {
              top: gameTableDimensions.height / 6,
              left: 40,
            };
            break;
          case 4:
            position = {
              top: 20,
              left: gameTableDimensions.width / 2,
            };
            break;
          case 5:
            position = {
              top: gameTableDimensions.height / 6,
              left: gameTableDimensions.width - 40,
            };
            break;
          case 6:
            position = {
              top: gameTableDimensions.height / 2.5,
              left: gameTableDimensions.width - 35,
            };
            break;
          case 7:
            position = {
              top: gameTableDimensions.height / 1.3,
              left: gameTableDimensions.width - 30,
            };
            break;
        }
      } else if (totalPlayers === 6) {
        switch (index) {
          case 0:
            position = {
              top: gameTableDimensions.height,
              left: gameTableDimensions.width / 2,
            };
            break;
          case 1:
            position = {
              top: gameTableDimensions.height / 1.3,
              left: 30,
            };
            break;
          case 2:
            position = {
              top: gameTableDimensions.height / 6,
              left: 40,
            };
            break;
          case 3:
            position = {
              top: 20,
              left: gameTableDimensions.width / 2,
            };
            break;
          case 4:
            position = {
              top: gameTableDimensions.height / 6,
              left: gameTableDimensions.width - 40,
            };
            break;
          case 5:
            position = {
              top: gameTableDimensions.height / 1.3,
              left: gameTableDimensions.width - 30,
            };
            break;
        }
      } else if (totalPlayers === 4) {
        switch (index) {
          case 0:
            position = {
              top: gameTableDimensions.height,
              left: gameTableDimensions.width / 2,
            };
            break;
          case 1:
            position = {
              top: gameTableDimensions.height / 6,
              left: 40,
            };
            break;
          case 2:
            position = {
              top: 20,
              left: gameTableDimensions.width / 2,
            };
            break;
          case 3:
            position = {
              top: gameTableDimensions.height / 6,
              left: gameTableDimensions.width - 40,
            };
            break;
          case 5:
            position = {
              top: gameTableDimensions.height / 1.25,
              left: gameTableDimensions.width - 45,
            };
            break;
        }
      } else if (totalPlayers === 2) {
        switch (index) {
          case 0:
            position = {
              top: gameTableDimensions.height,
              left: gameTableDimensions.width / 2,
            };
            break;
          case 1:
            position = {
              top: 20,
              left: gameTableDimensions.width / 2,
            };
            break;
        }
      }
      return position;
    },
    [gameTableDimensions.width, gameTableDimensions.height]
  );


  useEffect(() => {
    const handleSeatArrangements = () => {
      let array = Array.from({ length: Math.min(playersOnTable, 8) }, (_, index) => index);
      if (doesExist(playerSeat)) {
        const playerIndex = array.indexOf(playerSeat);
        if (playerIndex !== -1) {
          const reorderedArray = [
            ...array.slice(playerIndex),
            ...array.slice(0, playerIndex),
          ];
          setDefaultPlayersArray(reorderedArray);
        }
      } else {
        setDefaultPlayersArray(array);
      }
      setShowPlayersOnTable(true);
    };
    if (gameTableLoaded) {
      handleSeatArrangements();
    }
  }, [playerSeat, playersOnTable, gameTableLoaded]);

  useEffect(() => {
    if (defaultPlayersArray.length > 0) {
      let positionsArray = defaultPlayersArray.map((eachPlayer, index) => {
        let playerPosition = {
          clientChairIndex: eachPlayer,
          position: eachPlayer,
          top: returnPlayerPositions(playersOnTable, index).top,
          left: returnPlayerPositions(playersOnTable, index).left,
        };
        return playerPosition;
      });
      dispatch(
        updatePlayerPositionsOnTable({
          tempTableId: tempTableId,
          positions: positionsArray,
        })
      );
    }
  }, [defaultPlayersArray, playersOnTable, dispatch, returnPlayerPositions, tempTableId]);

  return (
    <div className={styles.playersLayoutContainer}>
      <div className={styles.playersLayoutRelativeContainer}>
        {defaultPlayersArray.length > 0 &&
          showPlayersOnTable &&
          defaultPlayersArray.map((position, index) => (
            <GameTableSeat
              position={position}
              clientChairIndex={index}
              tempTableId={tempTableId}
              key={index}
              coordinates={
                returnPlayerPositions(playersOnTable, index) || { top: 0, left: 0 }
              }
            />
          ))}
        <EmojiThrowManager tempTableId={tempTableId} />
      </div>
    </div>
  );
}
